import RouterSection from '@/layout/components/RouterSection'

const ADMIN_ROLES = ['usergroup001', 'usergroup002']
const ADMIN_ROLES_004 = ['usergroup001', 'usergroup002', 'usergroup004']

export default {
  path: '/manager',
  name: 'manager_home',
  component: RouterSection,
  redirect: { name: 'ManagerMenu' },
  meta: { roles: ADMIN_ROLES_004 },
  children: [
    {
      path: 'userManage',
      name: 'userManage',
      component: () => import('@/views/manager/UserManage.vue'),
      meta: { roles: ADMIN_ROLES_004 }
    },
    {
      path: 'program',
      name: 'ProgramManager',
      component: () => import('@/views/manager/ProgramManager.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'system',
      name: 'SystemManager',
      component: () => import('@/views/manager/SystemManager.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'menu',
      name: 'ManagerMenu',
      component: () => import('@/views/manager/ManagerMenu.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'n-menu',
      name: 'NewManagerMenu',
      component: () => import('@/views/manager/NewManagerMenu.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'authmanage/auth-group',
      name: 'AuthGroupManager',
      component: () => import('@/views/manager/AuthGroupManager.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'authmanage/auth-group-add-menu',
      name: 'AuthGroupAddMenu',
      component: () => import('@/views/manager/AuthGroupAddMenu.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'authmanage/auth-add-user',
      name: 'AuthAddUser',
      component: () => import('@/views/manager/AuthAddUser.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'authmanage/expanded-auth',
      name: 'ExpandedAuth',
      component: () => import('@/views/manager/ExpandedAuth.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'authmanage/user-add-menu-auth',
      name: 'UserAddMenuAuth',
      component: () => import('@/views/manager/UserAddMenuAuth.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'authmanage/user-auth',
      name: 'UserAuth',
      component: () => import('@/views/manager/UserAuth.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'etc-user',
      name: 'etc-user',
      component: () => import('@/views/manager/EtcUser.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'login-user-management',
      name: 'login-user-management',
      component: () => import('@/views/manager/LoginUserManagement.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'menu-log-management',
      name: 'menu-log-management',
      component: () => import('@/views/manager/MenuLog.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'commoncode',
      name: 'Commoncode',
      component: () => import('@/views/manager/Commoncode.vue'),
      meta: { roles: ADMIN_ROLES, asideView: false }
    },
    {
      path: 'login-log',
      name: 'LoginLog',
      component: () => import('@/views/manager/LoginLog.vue'),
      meta: { roles: ADMIN_ROLES, asideView: false }
    },
    {
      path: 'new-etc-org',
      name: 'NewEtcOrg',
      component: () => import('@/views/manager/NewEtcOrg.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'auth',
      name: 'auth',
      component: RouterSection,
      meta: { roles: ADMIN_ROLES },
      children: [
        {
          path: 'group',
          name: 'ManagerGroupAuth',
          component: () => import('@/views/manager/ManagerGroupAuth.vue'),
          meta: { roles: ADMIN_ROLES }
        },
        {
          path: 'menu-group',
          name: 'ManagerMenuGroupAuth',
          component: () => import('@/views/manager/ManagerMenuGroupAuth.vue'),
          meta: { roles: ADMIN_ROLES }
        },
        {
          path: 'user-group',
          name: 'ManagerUserGroupAuth',
          component: () => import('@/views/manager/ManagerUserGroupAuth.vue'),
          meta: { roles: ADMIN_ROLES }
        }
      ]
    },
    {
      path: 'user',
      name: 'ManagerUser',
      component: () => import('@/views/manager/ManagerUser.vue'),
      meta: { roles: ADMIN_ROLES }
    }
  ]
}
